import { API_ENDPOINTS } from "./config";

const AWARDS_API = API_ENDPOINTS.awards;

let awardsPageRequest = null;

export const fetchAwardsPage = async () => {
  if (awardsPageRequest) return awardsPageRequest;

  awardsPageRequest = fetch(AWARDS_API)
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch awards page data (${response.status})`);
      }

      const data = await response.json();

      return {
        awards: [...(data.awards || [])].sort((a, b) => a.id - b.id),
        contact: data.contacts?.[0] || null,
      };
    })
    .catch((error) => {
      awardsPageRequest = null;
      throw error;
    });

  return awardsPageRequest;
};
